var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 558,
  height: 223,
  viewBox: "0 0 558 223"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#417EFF",
  d: "M278 0c25.405 0 46 20.595 46 46s-20.595 46-46 46-46-20.595-46-46 20.595-46 46-46"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M291.822 33.17q4.877 0 8.36 3.659 3.485 3.658 3.485 8.71 0 3.83-2.178 6.967-2.177 3.135-5.66 4.529l-9.581 13.935q-.698.697-1.394.697-1.393 0-1.393-1.394 0-.348.348-1.045l8.013-11.497h-6.097l-5.4 7.665q-.696.696-1.22.697-1.567 0-1.567-1.394 0-.174.349-.87l4.354-6.098h-6.445l-9.232 13.239q-.695.697-1.22.697-1.567 0-1.567-1.394l.523-1.045 8.012-11.497h-6.27l-5.574 7.665q-.697.696-1.22.697-1.393 0-1.393-1.394 0-.348.348-1.045l4.355-5.923q-3.832-.174-6.445-3.048t-2.613-6.706 2.613-7.055 6.096-3.397a2.9 2.9 0 0 0-.087-.696 3 3 0 0 1-.087-.697q0-6.27 3.92-10.451 3.918-4.18 10.364-4.181 5.574 0 9.319 3.397t4.79 8.448q.349 0 .697-.087.349-.087.697-.087zm-.069 21.582q3.651 0 6.346-2.718t2.695-6.4-2.695-6.575-6.346-2.893h-1.043l-2.608.35-.521-2.63q-1.044-4.733-3.999-7.013-2.955-2.454-7.128-2.455-4.694 0-8.084 3.507t-3.39 8.241v3.857q-.696 0-1.565.176l-.87.175q-2.607.35-4.346 2.63t-1.739 4.91q0 2.805 1.913 4.734 2.085 2.104 4.52 2.104z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1B2437",
  d: "M232 50c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16 7.163-16 16-16"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8BA00",
  d: "M236.877 62.174a.44.44 0 0 1 .078.491l-6.026 12.913a.53.53 0 0 1-.47.28c-.044 0-.1-.012-.155-.023-.246-.078-.391-.313-.335-.547l2.198-9.018-4.53 1.127c-.045.011-.09.011-.135.011a.55.55 0 0 1-.346-.122.44.44 0 0 1-.145-.436l2.243-9.207a.496.496 0 0 1 .492-.357h3.66c.28 0 .502.212.502.468a.46.46 0 0 1-.055.201l-1.909 5.168 4.42-1.094a.6.6 0 0 1 .134-.022c.145 0 .279.067.38.167z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1B2437",
  d: "M232 9c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16 7.163-16 16-16"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8BA00",
  d: "M222.9 27.684h1.98c1.247 0 1.964.617 1.964 1.696 0 1.12-.717 1.773-1.965 1.773h-1.142v1.496h-.837zm.837.752v1.965h1.107c.766 0 1.198-.326 1.198-1 0-.653-.432-.965-1.198-.965zm6.58 4.213-.909-1.503c-.07.007-.149.007-.227.007h-1.177v1.496h-.837v-4.965h2.014c1.27 0 2 .617 2 1.696 0 .794-.368 1.354-1.028 1.61l1.113 1.66zm-2.313-2.248h1.177c.766 0 1.206-.326 1.206-1 0-.653-.44-.965-1.206-.965h-1.177zm6.004-2.738c1.482 0 2.631 1.085 2.631 2.504 0 1.418-1.149 2.518-2.63 2.518-1.483 0-2.632-1.1-2.632-2.518 0-1.426 1.149-2.504 2.631-2.504m.007.752c-.978 0-1.787.766-1.787 1.752s.816 1.766 1.787 1.766c.972 0 1.766-.78 1.766-1.766a1.75 1.75 0 0 0-1.766-1.752m3.012-.73h2.156c1.028 0 1.666.468 1.666 1.24 0 .56-.333.98-.872 1.107.667.114 1.064.589 1.064 1.255 0 .852-.688 1.362-1.809 1.362h-2.205v-4.965zm.836.744v1.312h1.277c.532 0 .851-.248.851-.666s-.319-.646-.85-.646zm0 2.05v1.425h1.277c.653 0 1.043-.255 1.043-.723 0-.44-.39-.702-1.043-.702zm-13.638-5.419h3.492v1.233h-4.852v-8.067h1.36zm7.567 1.233h-1.406l-3.216-8.067h1.464l2.49 6.557 2.512-6.557h1.418zm3.533-8.067h3.216c2.028 0 3.192 1.002 3.192 2.754 0 1.821-1.164 2.881-3.192 2.881h-1.856v2.432h-1.36zm1.36 1.221v3.193h1.798c1.245 0 1.948-.53 1.948-1.625 0-1.06-.703-1.568-1.948-1.568z"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 12,
  transform: "translate(5 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 48
}, "LVP probability")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 12,
  transform: "translate(5 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 388,
  y: 48
}, "Thunderstorm probability")), /*#__PURE__*/React.createElement("path", {
  fill: "#50E3C2",
  d: "M140 25h73v2h-73z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  stroke: "#50E3C2",
  strokeWidth: 2,
  transform: "translate(212 22)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  stroke: "#50E3C2",
  strokeWidth: 2,
  transform: "translate(133 22)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50E3C2",
  d: "M378 29h-2v49h2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50E3C2",
  d: "M378 76H247v2h131z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  stroke: "#50E3C2",
  strokeWidth: 2,
  transform: "matrix(-1 0 0 1 381 22)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  stroke: "#50E3C2",
  strokeWidth: 2,
  transform: "matrix(-1 0 0 1 248 73)"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#69728B",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(5 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 65
}, "Indicates probability"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 79
}, "of LVP status")), /*#__PURE__*/React.createElement("text", {
  fill: "#69728B",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(5 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 388,
  y: 65
}, "If visible, there's over 70% "), /*#__PURE__*/React.createElement("tspan", {
  x: 388,
  y: 79
}, "probability of thunderstorms")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 76,
  y: 165
}, "No rain or snow")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 78,
  y: 222
}, "Rain > 0 mm/h")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 251,
  y: 165
}, "Snow > 0 mm/h")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 249,
  y: 222
}, "Both rain and snow > 0 mm/h")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 12,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 442,
  y: 185
}, "Weather Alert indicator")), /*#__PURE__*/React.createElement("text", {
  fill: "#69728B",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 11,
  transform: "translate(-25 -18)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 442,
  y: 202
}, "If Weather Alert status is "), /*#__PURE__*/React.createElement("tspan", {
  x: 442,
  y: 216
}, "active, there is a indicator "), /*#__PURE__*/React.createElement("tspan", {
  x: 442,
  y: 230
}, "visible in the header")), /*#__PURE__*/React.createElement("path", {
  fill: "#1B2437",
  d: "M22 122c12.15 0 22 9.85 22 22s-9.85 22-22 22-22-9.85-22-22 9.85-22 22-22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.874 137.06v-3.639h1.078v3.639zm-9.703 7.142v-1.078h3.706v1.078zm2.965-7.21.674-.74 2.156 2.156-.741.74zm12.062 2.09-.742-.742 2.157-2.156.74.741zm-11.253 11.59-.674-.742 2.089-2.089.74.741zm4.919-3.842q-.405.338-.809.809-2.628-1.347-2.628-4.245 0-1.954 1.415-3.37 1.414-1.414 3.37-1.414 2.088 0 3.57 1.684-.74.338-.943.54-1.011-1.146-2.628-1.146-1.55 0-2.628 1.112-1.077 1.111-1.078 2.594 0 2.493 2.359 3.436m7.142-3.706q-1.752 0-2.998 1.247-1.247 1.246-1.247 2.931v.809l.067.673q-.201 0-.539.034a6 6 0 0 1-.404.034q-.944.135-1.583.842a2.38 2.38 0 0 0-.64 1.651q0 1.078.673 1.752.741.741 1.752.741h10.58q1.347 0 2.324-.977.977-.976.977-2.325 0-1.347-.977-2.358-.977-1.01-2.325-1.01a1 1 0 0 0-.202.033 1 1 0 0 1-.202.034l-.943.134-.202-.943q-.27-1.415-1.483-2.358a4.02 4.02 0 0 0-2.628-.944m0-1.078q1.887 0 3.302 1.18t1.82 2.93h.538q1.82 0 3.1 1.28 1.28 1.282 1.28 3.1 0 1.82-1.28 3.134t-3.1 1.314H20.087q-1.415 0-2.46-1.045a3.44 3.44 0 0 1-1.044-2.527q0-1.347.944-2.425.944-1.08 2.223-1.146v-.539q0-2.156 1.55-3.706c1.55-1.55 2.269-1.55 3.706-1.55"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#417EFF",
  d: "M22 179c12.15 0 22 9.85 22 22s-9.85 22-22 22-22-9.85-22-22 9.85-22 22-22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M28.61 194.864q2.333 0 4 1.75 1.665 1.75 1.665 4.165a5.7 5.7 0 0 1-1.041 3.332 5.9 5.9 0 0 1-2.708 2.166l-4.581 6.665q-.334.333-.667.333-.666 0-.666-.666 0-.167.166-.5l3.832-5.498h-2.915l-2.583 3.665q-.333.333-.583.334-.75 0-.75-.667 0-.083.167-.417l2.082-2.915h-3.082l-4.415 6.331q-.334.333-.583.333-.75 0-.75-.666l.25-.5 3.832-5.498h-3l-2.665 3.665q-.334.333-.583.334-.667 0-.667-.667 0-.167.167-.5l2.083-2.832q-1.833-.084-3.083-1.458-1.25-1.375-1.25-3.208 0-1.832 1.25-3.374 1.25-1.541 2.916-1.624a1.4 1.4 0 0 0-.042-.333 1.4 1.4 0 0 1-.041-.334q0-2.998 1.874-4.998t4.957-2q2.666 0 4.457 1.625c1.791 1.625 1.958 2.43 2.29 4.04q.168 0 .334-.041a1.4 1.4 0 0 1 .333-.042m-.032 10.322q1.745 0 3.035-1.3 1.288-1.3 1.288-3.061c0-1.761-.43-2.222-1.288-3.145q-1.29-1.383-3.035-1.383h-.5l-1.246.167-.25-1.257q-.5-2.265-1.912-3.355-1.414-1.174-3.41-1.174-2.244 0-3.866 1.677-1.62 1.678-1.621 3.942v1.845q-.333 0-.749.083l-.415.084q-1.248.168-2.079 1.258t-.832 2.348q0 1.343.915 2.264.998 1.007 2.162 1.007z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4DC8C9",
  d: "M192 122c12.15 0 22 9.85 22 22s-9.85 22-22 22-22-9.85-22-22 9.85-22 22-22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M202.692 149.463q.606.26.26.951-.26.606-.952.26l-2.508-1.47a4.2 4.2 0 0 0 0 2.075q.174.693-.605.865-.605.172-.779-.519-.345-1.902.087-3.113l-5.535-3.114v6.314q1.644.433 2.681 1.383.52.52.086.952-.519.52-.95.086-1.039-.864-1.817-1.038v2.854q0 .693-.692.692-.692 0-.692-.692v-2.854q-.778.174-1.816 1.038-.432.433-.951-.086c-.519-.519-.346-.663 0-.952q1.125-.951 2.767-1.383v-6.314l-5.621 3.114q.432 1.383.173 3.027-.173.778-.779.605-.778-.172-.605-.865a4.2 4.2 0 0 0 0-2.075l-2.508 1.47q-.692.345-.952-.26-.346-.691.26-.95l2.508-1.385q-.692-.691-1.816-1.124-.606-.173-.433-.865.26-.605.865-.432 1.47.432 2.595 1.643l5.621-3.113-5.621-3.2q-.952 1.125-2.595 1.643-.692.173-.865-.346-.172-.78.433-.951 1.21-.433 1.816-1.038l-2.508-1.384q-.606-.26-.26-.951.26-.606.952-.26l2.508 1.384q.26-.95 0-1.99-.173-.69.605-.864.606-.173.779.519a7.1 7.1 0 0 1-.173 3.113l5.621 3.114v-6.314q-1.643-.433-2.767-1.383-.519-.433 0-.952c.519-.519.663-.375.951-.086q1.038.864 1.816 1.038v-2.854q0-.692.692-.692t.692.692v2.854q.778-.174 1.816-1.038.433-.433.951.086.433.433-.086.952-1.038.951-2.681 1.383v6.314l5.535-3.114a7.1 7.1 0 0 1-.173-3.113q.173-.691.865-.52.692.174.519.866-.174.865.086 1.989L202 137.7q.693-.346.952.26.345.691-.26.95l-2.508 1.385q.692.692 1.816 1.124.606.173.433.865-.174.605-.865.432-1.73-.605-2.681-1.643l-5.535 3.114 5.535 3.113a6.75 6.75 0 0 1 2.68-1.643q.692-.173.866.432.172.692-.433.865-1.125.432-1.816 1.124l2.508 1.384z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C55A7",
  d: "M189 179c12.15 0 22 9.85 22 22s-9.85 22-22 22-22-9.85-22-22 9.85-22 22-22"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M181.346 204.174c.395 0 .714.321.714.718s-.32.717-.714.717c-2.552 0-4.612-2.148-4.612-4.782s2.06-4.78 4.612-4.78c.357 0 .707.03 1.006.093a.717.717 0 0 1-.29 1.405 3.7 3.7 0 0 0-.716-.064c-1.751 0-3.184 1.494-3.184 3.346s1.433 3.347 3.184 3.347"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M183.137 196.607a.675.675 0 1 1-1.332-.222c.57-3.417 3.498-5.964 6.947-5.964 2.855 0 5.391 1.756 6.492 4.384a.675.675 0 0 1-1.246.522c-.893-2.136-2.945-3.556-5.246-3.556-2.782 0-5.153 2.063-5.615 4.836"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M195.058 196.498a.68.68 0 0 1-.856-.473.72.72 0 0 1 .454-.892 4.8 4.8 0 0 1 1.485-.212c2.943 0 5.343 2.452 5.343 5.474 0 .394-.307.714-.686.714-.378 0-.685-.32-.685-.714 0-2.227-1.78-4.046-3.972-4.046-.413 0-.768.048-1.083.149m-10.738 10.966a.75.75 0 0 1-.99.32.703.703 0 0 1-.33-.959l2.46-4.759a.75.75 0 0 1 .99-.32.703.703 0 0 1 .33.959zm2.175 3.937a.693.693 0 0 1-.934.323.71.71 0 0 1-.318-.946l4.23-8.712a.693.693 0 0 1 .933-.322.71.71 0 0 1 .318.945l-4.23 8.712z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 0.6,
  d: "M200.212 208.478q.231.1.099.365-.099.232-.361.1l-.953-.565a1.64 1.64 0 0 0 0 .797q.066.266-.23.332-.23.067-.295-.2-.132-.73.033-1.194l-2.102-1.196v2.424q.624.166 1.018.531.197.2.033.366-.198.198-.362.033-.393-.332-.69-.399v1.096q0 .266-.262.266-.263 0-.263-.266v-1.096q-.296.067-.69.399-.164.166-.36-.033-.198-.2 0-.366a2.6 2.6 0 0 1 1.05-.53v-2.425l-2.135 1.196q.165.53.066 1.162-.066.298-.295.232-.296-.066-.23-.332a1.64 1.64 0 0 0 0-.797l-.953.565q-.262.132-.361-.1-.132-.266.098-.365l.953-.531a1.95 1.95 0 0 0-.69-.432q-.23-.066-.164-.332.099-.232.328-.166.559.165.986.63l2.134-1.195-2.134-1.228q-.362.432-.986.63-.262.067-.328-.132-.066-.3.164-.365.46-.166.69-.399l-.953-.53q-.23-.101-.098-.366.099-.232.361-.1l.953.531a1.5 1.5 0 0 0 0-.763q-.066-.266.23-.332.23-.067.295.199a2.75 2.75 0 0 1-.066 1.195l2.135 1.196v-2.424a2.6 2.6 0 0 1-1.05-.531q-.198-.166 0-.366.196-.2.36-.033.394.332.69.399v-1.096q0-.266.263-.266t.263.266v1.096q.296-.067.69-.399.164-.166.36.033.166.166-.032.366-.394.365-1.018.53v2.425l2.102-1.196a2.8 2.8 0 0 1-.066-1.195q.066-.266.328-.2.263.067.197.333a1.8 1.8 0 0 0 .033.763l.953-.53q.262-.134.36.099.133.266-.098.365l-.952.531q.263.266.69.432.23.066.164.332-.065.232-.329.166-.656-.233-1.018-.63l-2.102 1.194 2.102 1.196a2.56 2.56 0 0 1 1.018-.631q.263-.066.329.166.066.266-.164.332-.427.166-.69.432l.952.53z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6D00",
  d: "M422.128 127h29.744c1.783 0 2.43.186 3.082.534s1.163.86 1.512 1.512c.348.652.534 1.299.534 3.082v9.744c0 1.783-.186 2.43-.534 3.082a3.64 3.64 0 0 1-1.512 1.512c-.652.348-1.299.534-3.082.534h-29.744c-1.783 0-2.43-.186-3.082-.534a3.64 3.64 0 0 1-1.512-1.512c-.348-.652-.534-1.299-.534-3.082v-9.744c0-1.783.186-2.43.534-3.082a3.64 3.64 0 0 1 1.512-1.512c.652-.348 1.299-.534 3.082-.534"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M436.394 141h-1.452l-1.992-6.552-2.016 6.552h-1.464l-2.784-8.4h1.524l2.04 6.828 2.028-6.816 1.392-.012 2.04 6.828 2.028-6.828h1.464zm8.628-1.896h-4.236l-.804 1.896h-1.476l3.708-8.4h1.452l3.672 8.4h-1.512zm-.54-1.26-1.584-3.732-1.584 3.732z"
}))));
export default SvgContent;